import * as React from "react";

const SvgComponent = ({ width = "15px", height = "15px" }) => (
  <svg width={width} height={height} fill="none" viewBox="0 0 15 15 ">
    <rect
      x={0.5}
      y={0.5}
      width={14}
      height={14}
      rx={2.5}
      fill="transparent"
      stroke="var(--theme-background)"
    />
  </svg>
);

export default SvgComponent;
